import { render, staticRenderFns } from "./tatManagement.vue?vue&type=template&id=4fcbccd7&scoped=true"
import script from "./tatManagement.vue?vue&type=script&lang=js"
export * from "./tatManagement.vue?vue&type=script&lang=js"
import style0 from "./tatManagement.vue?vue&type=style&index=0&id=4fcbccd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbccd7",
  null
  
)

export default component.exports